import normalizeNetwork from './availableTrayWorkflow';

export default function traySolutionInstance(availableVendors) {
  return (rawInstance) => {
    const { vendor, logo, type } = normalizeNetwork({ node: rawInstance.solution });
    const socialiveAvailable = availableVendors.includes(vendor);

    return {
      id: rawInstance.id,
      title: rawInstance.name,
      enabled: rawInstance.enabled,
      socialiveAvailable,
      network: {
        logo,
        type,
        isReady: true,
        isSupported: true,
        id: rawInstance.id,
        title: rawInstance.name ?? vendor,
        vendor: vendor ?? rawInstance.name,
        description: '',
      },
      triggerUrl: rawInstance?.workflows?.edges?.[0]?.node?.triggerUrl,
    };
  };
}
